import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import html2canvas from "html2canvas";
import store from "../../store/store";
import { rem2px } from "../../utils";
import Avatar from "../Avatar/Avatar";
import { TEAM_COLORS } from "../../constants";

import ss from "./QRCodeModal.module.css";

// type: login, join
export const QRCodeModalComponent = () => {
  const { visible, url, onClose, type, ext } = useSelector(
    (state) => state.qrCodeModal
  );
  const [showQRCode, setShowQRCode] = useState(false);

  const closeModal = () => {
    setShowQRCode(false);
    setTimeout(() => {
      onClose?.();
    }, 600);
  };

  // 登录二维码
  const drawQRCode = () => {
    const qrcodeEle = document.getElementById("qrcode");
    window.QRCode &&
      new window.QRCode(qrcodeEle, {
        text: url,
        width: rem2px(648),
        height: rem2px(648),
        colorDark: "#111",
        colorLight: "#d4ff3e",
        correctLevel: window.QRCode.CorrectLevel.H,
      });
  };

  useEffect(() => {
    if (!visible) return;
    setShowQRCode(true);
    // load qrcode js
    const script = document.createElement("script");
    script.src = "/js/qrcode.min.js";
    script.async = false; // 可选，设置为true使脚本异步加载
    script.onload = () => {
      drawQRCode();
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, visible]);

  if (!visible) return null;

  return (
    <div className={classNames(ss.maskBg, showQRCode && ss.show)}>
      <div
        id="qrcode-modal"
        className={classNames(
          ss.modal,
          type === "join" && ss.join,
          type === "report" && ss.report
        )}
        onClick={() => {
          if (!window.confirm("保存到相册？")) return;
          const qrcodeModal = document.querySelector(`#qrcode-modal`);
          html2canvas(qrcodeModal, {
            backgroundColor: "#000000",
            allowTaint: true,
            useCORS: true,
          }).then((canvas) => {
            const dataUrl = canvas.toDataURL("image/jpeg", 0.7);
            const anchor = document.createElement("a");
            anchor.href = dataUrl;
            anchor.download = "photo.jpg";
            anchor.click();
            alert("已保存到相册！");
          });
        }}
      >
        {type === "join" && (
          <div className={ss.teamInfo}>
            <Avatar
              num={ext.teamColor}
              width={2.34}
              style={{ margin: "0.5rem auto 0" }}
            />
            <div
              className={ss.teamName}
              style={{ color: TEAM_COLORS[ext.teamColor] }}
            >
              【{ext.teamName}】
            </div>
          </div>
        )}
        <div className={ss.qrCodeBg}>
          <div id="qrcode" className={ss.qrCode}></div>
        </div>
      </div>
      <div className={ss.close} onClick={closeModal}></div>
    </div>
  );
};

export default class QRCodeModal {
  static show(payload) {
    store.dispatch.qrCodeModal.show(payload);
  }
  static hide() {
    store.dispatch.qrCodeModal.hide();
  }
}
